module.exports = __webpack_public_path__ + "img/1719-1722.3c12bf8a.jpg";